
@if (!filtersLoaded) {
  <div class="d-flex justify-content-center align-items-center" style="height: 200px;">
    <dx-load-indicator [visible]="true" height="60" width="60"></dx-load-indicator>
  </div>
} @else {
  <div class="custom-toolbar">
    <div id="before-toolbar" class="custom-toolbar-subdivision">
      <yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        [theme]="ButtonThemeEnum.ADD"
        label="CRÉER"
        iconClass="fa fa-plus"
        tooltip="Créer une proposition de commande"
        (onClick)="createCommande.toggle($event)" disabled>
        <p-menu appendTo="body" #createCommande [popup]="true" [model]="createCommandeOptionList" styleClass="context-menu"></p-menu>
      </yo-button>
      <yo-commande-fournisseur-date-filter
        [selectedDates]="[null, null]"
        (onValueChange)="onDateFilterValueChange($event)"
      >
      </yo-commande-fournisseur-date-filter>
      <dx-text-box
        class="box-size-1"
        placeholder="Filtrer par numéro de commande..."
        (onValueChanged)="onChangeFilterNumCommande($event)"
      >

      </dx-text-box>
      <dx-tag-box
        class="box-size-1"
        [multiline]="false"
        [dataSource]="filterItemsFournisseur"
        placeholder="Filtrer par fournisseur..."
        displayExpr="value"
        valueExpr="id"
        [searchEnabled]="true"
        [showSelectionControls]="true"
        (onValueChanged)="onChangeFilterFournisseurs($event)"
      >
        <div *dxTemplate="let fournisseur of 'item'">
          <div [title]="fournisseur.value">
            {{fournisseur.value}}
          </div>
        </div>
      </dx-tag-box>
      <dx-tag-box
        class="box-size-1"
        [multiline]="false"
        [dataSource]="filterItemsUdp"
        placeholder="Filtrer par unité de production..."
        displayExpr="value"
        valueExpr="id"
        [searchEnabled]="true"
        [showSelectionControls]="true"
        (onValueChanged)="onChangeFilterUdps($event)"
      >
      </dx-tag-box>

      <dx-text-box
        class="box-size-1"
        placeholder="Filtrer par article..."
        (onValueChanged)="onChangeFilterArticles($event)"
      >
      </dx-text-box>

      <dx-tag-box
        class="box-size-2"
        [dataSource]="filterItemsListeBesoin"
        placeholder="Filtrer par liste de besoins..."
        displayExpr="value"
        valueExpr="id"
        [searchEnabled]="true"
        [showSelectionControls]="true"
        [multiline]="false"
        (onValueChanged)="onChangeFilterListesBesoins($event)"
      >
      </dx-tag-box>
    </div>
    <div id="after-toolbar" class="custom-toolbar-subdivision">
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        iconClass="fas fa-play"
        tooltip="Passer à l'étape suivante"
        [disabled]="isActionDisabled"
        (onClick)="menu.toggle($event)">
        <p-menu appendTo="body" #menu [popup]="true" [model]="nextSteps"></p-menu>
      </yo-button>
      <yo-button
        iconClass="fa fa-envelope"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="openPopupSendMail()"
        [disabled]="isActionDisabled || isSendMailDisabled"
        tooltip="Envoyer par mail les commandes aux fournisseurs sélectionnés">
      </yo-button>
      <yo-button
        iconClass="fas fa-print"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="printPDFCommandes()"
        [disabled]="isActionDisabled"
        tooltip="Imprimer les propositions sélectionnées au format pdf">
      </yo-button>
      <yo-button
        iconClass="fas fa-code-merge"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="prepareToMergeBonsCf()"
        [disabled]="isActionDisabled"
        tooltip="Fusionner les propositions sélectionnées">
      </yo-button>
      <yo-button
        iconClass="fa fa-trash"
        [theme]="ButtonThemeEnum.DELETE_INNER"
        (onClick)="deleteBonCfs()"
        [disabled]="isActionDisabled"
        tooltip="Supprimer les propositions sélectionnées">
      </yo-button>
    </div>
  </div>

  <dx-data-grid
    (onSelectionChanged)="checkDisabledButtons()"
    [dataSource]="dataSource"
    [remoteOperations]="true"
    [renderAsync]="true"
    keyExpr="id"
    [height]="utils.getWindowAvailableHeight(182)"
    width="100%"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [showRowLines]="true"
    [showBorders]="true"
    [allowColumnResizing]="true"
    (onCellClick)="cellClick($event)"
    #grid>

    <dxo-load-panel
      [enabled]="true"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [text]="'Chargement en cours...'"
    ></dxo-load-panel>

    <dxo-selection [allowSelectAll]="true" [showCheckBoxesMode]="checkBoxesMode"
                   mode="multiple"></dxo-selection>

    <dxi-column dataField="id" caption="Actions" [width]="120" cellTemplate="templateActions"
                [allowSorting]="false"></dxi-column>
    <dxi-column dataField="numeroBcf" caption="Bon de commande" cellTemplate="templateBonCf">

    </dxi-column>
    <dxi-column dataField="dateCommande" caption="Date commande" cellTemplate="templateDateCommande">

    </dxi-column>
    <dxi-column dataField="dateLivraisonAjustee" alignement="left" caption="Date livraison"
                cellTemplate="templateDateLivraison"></dxi-column>
    <dxi-column dataField="fournisseurLibelle" caption="Fournisseur"></dxi-column>
    <dxi-column dataField="uniteDeProductionLibelle" caption="Unité de production"
                cellTemplate="templateUdp"></dxi-column>
    <dxi-column dataField="montantHT" caption="Montant HT" alignment="left" cellTemplate="templateMontantHT"></dxi-column>
    <dxi-column dataField="commentaire" caption="Remarque(s)" alignment="left"
                cellTemplate="templateRemarques"></dxi-column>
    <dxi-column dataField="listeBesoinLibelle" caption="Liste de besoins" alignment="left"
                cellTemplate="templateLbde"></dxi-column>

    <div *dxTemplate="let cell of 'templateActions'" class="custom-button-container">
      <yo-button size="small"
                      [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openEditFournisseurDialog(cell.row.data,false)"
                      [iconClass]="auth2Svc.isSiteLocal(cell.row.data.site.id)? 'fas fa-edit':'fas fa-eye'"
                      [tooltip]="auth2Svc.isSiteLocal(cell.row.data.site.id)? 'Modifier la commande':'Voir la commande'">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT_INNER"
        iconClass="fas fa-clone"
        tooltip="Dupliquer la proposition sélectionnée"
        size="small"
        (onClick)="prepareToDuplicateBonCf(cell.row.data)">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT_INNER"
        iconClass="fas fa-truck"
        tooltip="Réassigner la proposition sélectionnée"
        size="small"
        (onClick)="openReassignDialog(cell.row.data)">
      </yo-button>
    </div>
    <div *dxTemplate="let cell of 'templateUdp'">
      <td>
        <yo-site [siteId]="cell.row.data.site.id" [siteLibelleTooltip]="cell.row.data.site.libelle"
                 [siteLibelle]="cell.row.data.uniteDeProductionLibelle"></yo-site>
      </td>
    </div>
    <div *dxTemplate="let cell of 'templateDateCommande'">
      <td style="text-align: right;">
        {{ cell.row.data.dateCommande | date:'dd/MM/yyyy' | titlecase }}
      </td>
    </div>
    <div *dxTemplate="let cell of 'templateDateLivraison'">
      <td style="text-align: right;">
        {{ cell.row.data.dateLivraisonAjustee | date:'dd/MM/yyyy' | titlecase }}
      </td>
    </div>
    <div *dxTemplate="let cell of 'templateMontantHT'">
      <td style="text-align: right;">
        {{ cell.row.data.montantHT | currency:'EUR':'symbol':'1.4-4' }}
        @if (isMinimumCommandInError(cell.row.data)) {
          <span>
                <i class="fas fa-cart-arrow-down danger-color space"
                   title="Minimum de commande non atteint"></i>
          </span>
        }
        @if (isConditionneParInError(cell.row.data)) {
          <span>
                <i class="fas fa-box-open danger-color space"
                   title="Conditionné par non respecté"></i>
          </span>
        }
        @if (isFraisPortApplyed(cell.row.data)) {
          <span>
              <i class="fas fa-truck danger-color space"
                 title="Des frais de port sont appliqués"></i>
          </span>
        }
        @if (isHorsDelai(cell.row.data)) {
          <span>
              <i class="fas fa-business-time danger-color space"
                 title="Article avec délai de commande spécifique dépassé"></i>
          </span>
        }
      </td>
    </div>
    <div *dxTemplate="let cell of 'templateRemarques'">
      <td style="text-align: left;"
      >
        <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(utils.stripeHtml(cell.row.data.commentaire))">
        </p>
      </td>
    </div>
    <div *dxTemplate="let cell of 'templateLbde'">
      <td style="text-align: left;">
        <a title="Aller sur la liste de besoins"
           (click)="wkfSvc.goToListeBesoinsDetails(cell.row.data.workflowInstance)"><span
          class="cursor save-color">{{cell.row.data.listeBesoinLibelle}}</span></a>
      </td>
    </div>
    <div *dxTemplate="let cell of 'templateBonCf'">
      <div>
        <span class="mg-r-5">{{cell.row.data.numeroBcf}}</span>
        <yo-email-histo-button
          [code]="cell.row.data.numeroBcf"
          [emailHisto]="cell.row.data.mailHisto"
          (onMailHistoRetrieve)="onEmailHistoRretreived($event)">
        </yo-email-histo-button>
      </div>
      <div>
        <yo-gef-audit-button
          [gefAuditList]="this.gefSvc.retrieveGefAuditListByIdEntity(gefAuditListBonCommande, cell.row.data.id)">
        </yo-gef-audit-button>
      </div>
    </div>

    <dxo-sorting mode="single"></dxo-sorting>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} proposition(s)">
    </dxo-pager>

  </dx-data-grid>
}

<!--DIALOG MODIFIER UNE PROPOSITION DE COMMANDE-->
@if (displayEditDialog) {
  <yo-bc-edit-fournisseur
    [displayDialog]="displayEditDialog"
    (onSave)="onPropositionAdded()"
    (onClose)="displayEditDialog=$event"
    [bonCf]="bonCf"
    [lignesBonCf]="lignesBonCf"
    [bonCfs]="propositionsCommandes">
  </yo-bc-edit-fournisseur>
}


<!--DIALOG CRÉER UNE NOUVELLE PROPOSITION DE COMMANDE PAR FOURNISSEUR-->
@if (displayAddDialog) {
  <yo-create-proposition-fournisseur
    [displayDialog]="displayAddDialog"
    [uniteDeProductionList]="uniteDeProductionList"
    (onSave)="newPropositionCommande($event)"
    (onClose)="displayAddDialog=$event">
</yo-create-proposition-fournisseur>
}

@if (displayCreatePropositionDenreeDialog) {
  <yo-create-proposition-denree [displayDialog]="displayCreatePropositionDenreeDialog">
  </yo-create-proposition-denree>
}

@if (displayMergeDialog) {
  <yo-merge-boncf
    #mergeComponent
    [displayDialog]="displayMergeDialog"
    [selectedBonCfsToMerge]="selectedBonCfsToMerge"
    [uniteDeProduction]="selectedUniteDeProductionToMerge"
    (onSave)="mergeBonsCf($event)"
    (onClose)="onCloseMerge($event)">
  </yo-merge-boncf>
}

@if (displayDuplicationDialog) {
  <yo-duplication-boncf
    #duplicationComponent
    [displayDialog]="displayDuplicationDialog"
    [selectedBonCfToDuplicate]="selectedBonCfToDuplicate"
    [uniteDeProduction]="selectedUniteDeProductionToDuplicate"
    (onSave)="duplicateBNonCf($event)"
    (onClose)="onCloseDuplication($event)">
  </yo-duplication-boncf>
}

@if (displayReassignBcFournisseurDialog) {
  <yo-reassignBcFournisseurDialog [displayDialog]="displayReassignBcFournisseurDialog">
  </yo-reassignBcFournisseurDialog>
}

<dx-popup
  [showTitle]="true"
  title="Éléments sans correspondance "
  [visible]="displayNoCorrespondancePopup"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeNoCorrespondancePopup(false)"
>
  <label>Les éléments non présents dans cette liste ont bien été réassignés.</label>
  <dx-data-grid
    [dataSource]="noCorrespondanceList"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    columnResizingMode="widget"
  >
    <dxi-column dataField="referenceArticle" caption="Réf. article" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxi-column dataField="description" caption="Description" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>
  <div class="d-flex mg-t-10 justify-content-end">
    <yo-button
      class="mg-l-5"
      [theme]="ButtonThemeEnum.DEFAULT"
      label="Ouvrir le nouveau bon de commande"
      (onClick)="closeNoCorrespondancePopup(true)"
      iconClass="fas fa-external-link">
    </yo-button>
  </div>
</dx-popup>

@if (displayPopupSendMail) {
  <yo-send-mail
    [displayDialog]="displayPopupSendMail"
    (onSave)="sendEmail($event)"
    (onClose)="onCloseSendMail($event)">
  </yo-send-mail>
}
